import React, {useEffect, useRef, useState} from "react";
import DataHeaderType from "src/old/Types/DataHeaderType";
import * as ST from "./styled";
import SubMenuItem from "../SubMenuItem";
import SubMenuItemText from "../SubMenuItemText";
import Colors from "../../../../../general/constants/colors";

interface MenuAccordionType {
	items: DataHeaderType[]
	isVisible: boolean
}

const MenuAccordion: React.FC<MenuAccordionType> = ({items, isVisible}) => {
	const subMenuRef = useRef<HTMLDivElement>(null);
	const [activeSubMenuIndex, setActiveSubMenuIndex] = useState<number | null>(null);

	useEffect(() => {
		if (subMenuRef.current) {
			subMenuRef.current.style.display = isVisible ? 'flex' : 'none';
		}
	}, [isVisible]);

	return (
		<ST.SubMenuContainer ref={subMenuRef}>
			<ul style={{
				padding: "15px 0"
			}}>
				{items.map((item, index) => (
					<SubMenuItem
						key={item.id}
						onClick={(event) => {
							setActiveSubMenuIndex(index)
						}}
						style={{
							padding: "4px 0",
							display: "block",
						}}
					>
						<SubMenuItemText
							text={item.name}
							sx={{
								color: index === activeSubMenuIndex ? Colors.GREEN : "inherit",
							}}
							sxWrapper={{
								padding: "0 25px"
							}}
						/>

						{(items[index]?.children ?? []) && (
							<ST.SubMenuThirdItems
								style={{
									height: activeSubMenuIndex === index ? `${(items[index].children ?? []).length * 45}px` : "0px",
								}}
							>
								{(items[index].children ?? []).map((item) => (
									<SubMenuItem
										key={item.id}
										style={{
											paddingLeft: 0
										}}
									>
										<a href={item.path} style={{textDecoration: "none"}}>
											<SubMenuItemText text={item.name} />
										</a>
									</SubMenuItem>
								))}
							</ST.SubMenuThirdItems>
						)}
					</SubMenuItem>
				))}
			</ul>
		</ST.SubMenuContainer>
	)
}

export default MenuAccordion